import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { chargesQueries, ChargeType } from '@/services/charges/charges.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useChargeMutation = (activeTab: ChargeType) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('createCharge', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargesQueries.all(activeTab) });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
